export default __webpack_public_path__ + "static/Customer-experience-5076cc78c191b4522b5ac474daa8e893.webp";